import { useSelector } from 'react-redux';
import { TemplateReport } from '../../models';
import { selectTemplateList } from '../../selectors';

export const useTemplateList = (): TemplateReport[] => {
  const templates = useSelector(selectTemplateList);

  return templates;
};
